import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import type { Contract, FormSchema } from '../types'
import { SectionForm } from './SectionForm'
import { SectionVisibilityBadge, visibilityMode } from './SectionVisibilityBadge'

type Props = {
  contract: Contract
  schema: FormSchema
}

export function SectionTabs({ contract, schema }: Props) {
  // Backend zwraca sekcje już w kolejności per-produkt (PRODUCT_FORM_SECTION.SORT_ORDER).
  // Pole FormSection.sortOrder reprezentuje globalny porządek z FORM_SECTION i nie powinno
  // być tu używane do re-sortowania - sortowanie nim łamałoby kolejność z produktu.
  // Sekcje SIDEBAR nie renderują się jako taby (Task 10 doda je jako sidebar).
  const orderedCodes = schema.sections
    .filter(s => s.renderTarget !== 'SIDEBAR')
    .map(s => s.code)
  const visibleSections = orderedCodes.filter(code => {
    const v = contract.sectionVisibility[code]
    return visibilityMode(v) !== 'HIDDEN'
  })

  if (visibleSections.length === 0) {
    return <div className="p-4 text-sm text-slate-500">Brak dostępnych sekcji dla Twojej roli.</div>
  }

  return (
    <Tabs defaultValue={visibleSections[0]} className="flex flex-col gap-0">
      <TabsList className="rounded-none w-full justify-start gap-1 px-6 border-b border-slate-200 bg-white h-auto py-0 shadow-none sticky top-0 z-10">
        {visibleSections.map(code => {
          const section = schema.sections.find(s => s.code === code)
          const label = section?.labelPl ?? code
          return (
            <TabsTrigger
              key={code}
              value={code}
              className="relative gap-2 px-3 py-2.5 text-sm text-slate-500 hover:text-slate-900 rounded-none shadow-none data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-slate-900 data-[state=active]:font-semibold after:absolute after:left-2 after:right-2 after:-bottom-px after:h-0.5 after:bg-slate-900 after:rounded-full after:opacity-0 data-[state=active]:after:opacity-100 transition-colors"
            >
              {label}
              <SectionVisibilityBadge visibility={contract.sectionVisibility[code]} />
            </TabsTrigger>
          )
        })}
      </TabsList>
      {visibleSections.map(code => (
        <TabsContent key={code} value={code}>
          <SectionForm
            contract={contract}
            schema={schema}
            sectionCode={code}
            visibility={contract.sectionVisibility[code]}
          />
        </TabsContent>
      ))}
    </Tabs>
  )
}
